import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const frTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nom (minuscules, sans caractères spéciaux)',
    add: 'Ajouter',
    allowedFileTypes: 'Types de fichiers autorisés',
    allowedFileTypesDescription:
      'Restreignez les types de fichiers autorisés (par exemple, image/*, application/pdf). Laissez vide pour autoriser tous les types.',
    allowMultipleFiles: 'Autoriser plusieurs fichiers',
    amountInCents: 'Montant en centimes',
    basePrice: 'Prix de base',
    bcc: 'CCI',
    brand: 'Marque',
    cc: 'CC',
    checkboxPlural: 'Champs checkbox',
    checkboxSingular: 'Checkbox',
    checkedByDefault: 'Coché par défaut',
    chooseConfirmationType:
      'Choisissez si vous souhaitez afficher un message sur la page ou rediriger vers une autre page après la soumission du formulaire.',
    condition: 'Condition',
    confirmationMessage: 'Message de confirmation',
    confirmationType: 'Type de confirmation',
    countryPlural: 'Champs pays',
    countrySingular: 'Pays',
    creditCard: 'Carte de crédit',
    customURL: 'URL personnalisée',
    datePlural: 'Champs date',
    dateSingular: 'Date',
    defaultValue: 'Valeur par défaut',
    divide: 'Diviser',
    documentToLinkTo: 'Document à lier',
    doesNotEqual: "N'est pas égal à",
    emailFrom: 'Email de l’expéditeur',
    emailPlural: 'Champs email',
    emailsDescription:
      "Envoyez des emails personnalisés lors de la soumission du formulaire. Utilisez des listes séparées par des virgules pour envoyer le même email à plusieurs destinataires. Pour référencer une valeur de ce formulaire, entourez le nom du champ avec des doubles accolades, par exemple {{firstName}}. Vous pouvez utiliser le caractère générique {{*}} pour afficher toutes les données et {{*:table}} pour les formater sous forme de tableau HTML dans l'email.",
    emailSingular: 'Email',
    emailTo: 'Email du destinataire',
    equals: 'Est égal à',
    field: 'Champ',
    fields: 'Champs',
    fieldWidth: 'Largeur du champ (pourcentage)',
    hasAnyValue: 'A une valeur',
    internalLink: 'Lien interne',
    label: 'Label',
    maxFileSize: 'Taille maximale du fichier (bytes)',
    maxFileSizeDescription: 'Taille maximale du fichier en bytes. Laissez vide pour aucune limite.',
    message: 'Message',
    messageDescription: 'Saisissez le message à envoyer dans cet email.',
    messagePlural: 'Blocs message',
    messageSingular: 'Message',
    mimeType: 'Type MIME',
    mimeTypePlural: 'Types MIME',
    mimeTypeSingular: 'Type MIME',
    multiply: 'Multiplier',
    numberPlural: 'Champs nombre',
    numberSingular: 'Nombre',
    optionPlural: 'Options',
    optionSingular: 'Option',
    paymentFieldPlural: 'Champs paiement',
    paymentFieldSingular: 'Paiement',
    paymentProcessor: 'Processeur de paiement',
    paymentStatus: 'Statut',
    placeholder: 'Placeholder',
    priceConditions: 'Conditions de prix',
    priceConditionsPlural: 'Conditions de prix',
    priceConditionsSingular: 'Condition de prix',
    radioOptions: 'Options du radio',
    radioPlural: 'Champs radio',
    radioSingular: 'Champ radio',
    redirect: 'Redirection',
    replyTo: 'Répondre à',
    required: 'Requis',
    selectOptions: 'Options du select',
    selectPlural: 'Champs select',
    selectSingular: 'Select',
    statePlural: 'Champs état',
    stateSingular: 'État',
    staticValue: 'Valeur statique',
    subject: 'Sujet',
    submitButton: 'Label du bouton de soumission',
    subtract: 'Soustraire',
    textareaPlural: 'Champs textarea',
    textareaSingular: 'Textarea',
    textPlural: 'Champs texte',
    textSingular: 'Texte',
    title: 'Titre',
    token: 'token',
    uploadCollection: 'Collection de fichiers',
    uploadCollectionDescription: 'Sélectionnez la collection de fichiers à stocker',
    uploadFieldPlural: 'Champs upload',
    uploadFieldSingular: 'Upload',
    urlToRedirectTo: 'URL de redirection',
    value: 'Valeur',
    valueOfField: 'Valeur du champ',
    valueType: 'Type de valeur',
  },
}

export const fr: PluginLanguage = {
  dateFNSKey: 'fr',
  translations: frTranslations,
}
